import React from 'react';
import { BrowserRouter, MemoryRouter } from 'react-router-dom';

import HELPER_CONSTANTS from '../../utils/helper.js';
import { isInIframe } from '../../utils/embedHelper.js';

export const AppRouter = ({ children }) => {
  const unlockAPICall = status => {
    if (status) {
      console.log(status, 'you can able to do api call');
    }
  };

  // use memory router if application is loaded inside iframe so it will not affect the browser path.
  const Router = isInIframe ? MemoryRouter : BrowserRouter;
  const props = {
    getUserConfirmation: (message, callback) => {
      // this is the default behavior
      const allowTransition = window.confirm(message);
      console.log(allowTransition, message);
      unlockAPICall(allowTransition);
      callback(allowTransition);
    },
    basename: HELPER_CONSTANTS.DEPLOYMENT_URL,
  };
  if (isInIframe) {
    // when switching from browser router to memory router in embedded mode, initial entries populated by the initial route from location.pathname.
    props.initialEntries = [window.location.pathname];
  }
  return <Router {...props}>{children}</Router>;
};
